import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Compass } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <>
      <Navbar />
      
      <div className="min-h-[70vh] bg-gray-50 flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full text-center">
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="absolute -inset-1 bg-ta-green/20 rounded-full animate-pulse"></div>
              <div className="relative h-24 w-24 bg-white rounded-full flex items-center justify-center border-2 border-ta-green">
                <Compass className="h-12 w-12 text-ta-green" />
              </div>
            </div>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Page Not Found</h1>
          <p className="text-gray-600 mb-8">
            The safari trail you were following seems to have disappeared into the wilderness. Let's get you back on track.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-ta-green text-white rounded-lg hover:bg-ta-green-dark transition-colors"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Back to Home
            </Link>
            
            <Link 
              to="/uganda-trips"
              className="inline-flex items-center justify-center px-6 py-3 border border-ta-green text-ta-green rounded-lg hover:bg-ta-green/5 transition-colors"
            >
              <MapPin className="h-5 w-5 mr-2" />
              Explore Trips
            </Link>
          </div>
          
          <div className="mt-12 text-sm text-gray-500">
            <p>Lost? Contact us at <a href="mailto:info@travelcord.guide" className="text-ta-green hover:underline">info@travelcord.guide</a></p>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default NotFound;